export default {
  'PageLoading.WeChatCanEnterTheAccessAfterAuthorizationRequestAuthorization':
    'WeChat can enter the access after authorization, request authorization...',
  'PageLoading.OhWellSomethingWentWrong': 'Oh well, something went wrong!',
  'PageLoading.ShoutingIsComing': 'Jojo is coming...'
};
